// src/services/SuccessStoryService.js
import api from "./api";

export function getSuccessStory(page = 1, limit = 10, search = "") {
  return api.get(`/successstory?page=${page}&limit=${limit}&search=${search}`);
}

export function getSuccessStoryById(id) {
  return api.get(`/successstory/${id}`);
}

export function addSuccessStory(data) {
  return api.post("/successstory", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateSuccessStory(id, data) {
  return api.put(`/successstory/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteSuccessStory(id) {
  return api.delete(`/successstory/${id}`);
}
